
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","opacity":".347","cx":"32","cy":"32","r":"32"}}),_c('path',{attrs:{"fill":"#000","d":"M21.957 24.085h20v14h-20z"}}),_c('path',{attrs:{"fill":"#2CC692","d":"M24 27h16v7H24z"}}),_c('path',{attrs:{"d":"M45.19 22.32H19.467v18.13h8.895v.954h7.693v-.954h9.135l-.002-18.13zm3.874 20.74h-34.09a2.154 2.154 0 01-1.518-.616 2.087 2.087 0 01-.626-1.495v-.47h3.813v-18.77a1.84 1.84 0 01.55-1.335c.36-.354.85-.55 1.357-.542h26.7c.977-.034 1.813.685 1.907 1.642v18.772h3.814v.704c.1.543-.06 1.1-.432 1.512a1.839 1.839 0 01-1.475.6z","fill":"#000"}})])])
          )
        }
      }
    